/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * A status with count.
 * @export
 * @interface StatusCount
 */
export interface StatusCount {
    /**
     * The number of occurrences of the status.
     * @type {number}
     * @memberof StatusCount
     */
    'count'?: number;
    /**
     * The status.
     * @type {string}
     * @memberof StatusCount
     */
    'status': StatusCountStatusEnum;
}

export const StatusCountStatusEnum = {
    VIEW_STATUS_UNSPECIFIED: 'VIEW_STATUS_UNSPECIFIED',
    FAILED: 'FAILED',
    WARNING: 'WARNING'
} as const;

export type StatusCountStatusEnum = typeof StatusCountStatusEnum[keyof typeof StatusCountStatusEnum];


